import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

export interface ICardNumberReassignDialogData {
  parkerName: string;
  cardNumber: string;
  parkerId: string;
  isActive: boolean;
}

@Component({
  selector: 'app-dialog-card-number-reassign',
  standalone: true,
  imports: [MatButtonModule, MatCardModule, MatDialogModule],
  templateUrl: './dialog-card-number-reassign.component.html',
  styleUrl: './dialog-card-number-reassign.component.scss',
})
export class DialogCardNumberReassignComponent {
  parkerName: string;
  parkerId: string;
  currentCardNumber: string;
  isActive: boolean;
  activeDisplay: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ICardNumberReassignDialogData) {
    this.parkerName = data.parkerName;
    this.parkerId = data.parkerId;
    this.currentCardNumber = data.cardNumber;
    this.isActive = data.isActive;

    this.isActive ? (this.activeDisplay = 'Active') : (this.activeDisplay = 'Inactive');
  }
}
